import type { TranslationMessages } from '../../types';

export const points: TranslationMessages = {
  title: 'Points',
  current_balance: 'Current Balance',
  points_history: 'Points History',
  transaction_type: 'Transaction Type',
  earned: 'Earned',
  spent: 'Spent',
  bonus: 'Bonus',
  penalty: 'Penalty',
  redemption: 'Redemption',
  adjustment: 'Adjustment',
  reason: 'Reason',
  description: 'Description',
  amount: 'Amount',
  date: 'Date',
  filter_by_reason: 'Filter by Reason',
  all_reasons: 'All Reasons',
  checklist_completion: 'Checklist Completion',
  perfect_attendance: 'Perfect Attendance',
  customer_compliment: 'Customer Compliment',
  badge_achievement: 'Badge Achievement',
  above_and_beyond: 'Above and Beyond',
  teamwork: 'Teamwork',
  missing_checklist: 'Missing Checklist',
  late_arrival: 'Late Arrival',
  customer_complaint: 'Customer Complaint',
  policy_violation: 'Policy Violation',
  no_show: 'No Show',
  early_leave: 'Early Leave',
};
